/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class LockConfigResourcesRequest {
    getFixupPrototypeFunction() { return LockConfigResourcesRequest.fixupPrototype; }

    static newInstance(model: Partial<LockConfigResourcesRequest>): LockConfigResourcesRequest {
        let obj = Object.assign(new LockConfigResourcesRequest(), model);
        LockConfigResourcesRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<LockConfigResourcesRequest>): LockConfigResourcesRequest {
        if (!model) return null;
        return LockConfigResourcesRequest.newInstance(<LockConfigResourcesRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: LockConfigResourcesRequest) {
        if (!obj) return;

        models.LockConfigResourcesRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: LockConfigResourcesRequest): boolean {
        Object.setPrototypeOf(obj, LockConfigResourcesRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Service Account ID
     */
    service_account_id: string;

}
